import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description ClockTimeOff icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { ClockTimeOff } from '@sravni/design-system-icons'
 *
 * <ClockTimeOff />
 * ```
 */
var ClockTimeOff = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "ClockTimeOff", viewBox: "0 0 21 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "m18.236 18.333-15-15M6.022 6.118a6.666 6.666 0 0 0 9.428 9.425M16.807 13.567c.73-1.618.821-3.519.088-5.288a6.665 6.665 0 0 0-8.71-3.608c-.064.027-.124.06-.187.09M9.07 1.667h3.333M17.403 4.167l-1.95 1.95M16.57 3.333 18.235 5", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { ClockTimeOff };
//# sourceMappingURL=ClockTimeOff.js.map
